<div class="homepage-sip-banner-1" (click)="redirect($event)">
  <img class="tax" src="/assets/images/tax_benefit_new.gif" alt="tax">
  <div class="container">
    <div class="content">
      <img [attr.data-src]="'assets/images/sip-banner-new-child.png'" alt="sip" [default]="util.defaultImg">
      <div class="text-content">
        <div class="title">Impact Lives with Monthly Donations!</div>
        <div class="text">Sign up to support lives in urgent need of funds. Save lives every month with automated donations.</div>
      </div>
    </div>
    <div class="btn">
      <button><span class="btn-text">Donate Monthly</span></button>
      <span class="know">Know More</span>
    </div>
  </div>
</div>

